import gql from 'graphql-tag';

export default gql`
  query UsersQuery {
    UserMany {
      _id
      email
      chat_id
      subscriptions
      role
      createdAt
    }
  }
`;
